import Styles from './PostApproval.module.scss'
import { Button } from 'blaze-ui/Button'
import { AlmanacFileShowItem } from 'hooks/queries/files/types'
import dayjs from 'dayjs'
import { useHover } from '@react-aria/interactions'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { DesignChannel } from 'components/NewFileModal/Types'
import { PostingOnMenu } from '../Toolbar/PostingOnMenu'
import { CalendarFilters } from 'screens/Calendar/types'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
interface RejectedButtonProps {
  almanacFile: AlmanacFileShowItem
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  onDelete: () => void
  onUpdateAlmanacFile?: (updatedFile: AlmanacFileShowItem) => void
  filters: CalendarFilters
  fileChannel: ChannelType | DesignChannel | GenerationType
  startDate?: string
  goToNextFile?: () => void
}

export const RejectedButton = ({
  almanacFile,
  isLoading,
  setIsLoading,
  onDelete,
  onUpdateAlmanacFile,
  filters,
  fileChannel,
  startDate,
  goToNextFile,
}: RejectedButtonProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { hoverProps, isHovered } = useHover({})
  const hoveredText = goToNextFile ? 'Schedule' : 'Approve & Schedule'
  const defaultText = goToNextFile
    ? `Draft ${dayjs(almanacFile.reviewed_at).format('M/D')}`
    : `Moved to Draft on ${dayjs(almanacFile.reviewed_at).format('MMM D')}`
  const buttonText = isHovered ? hoveredText : defaultText

  if (!almanacFile.reviewed_at) return null

  return (
    <div className={Styles.buttons}>
      <PostingOnMenu
        almanacFile={almanacFile}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        onDelete={onDelete}
        filters={filters}
        fileChannel={fileChannel}
        startDate={startDate}
        onUpdateAlmanacFile={onUpdateAlmanacFile}
        reviewAndSchedule
        trigger={
          <div {...hoverProps} className={Styles.buttonContainer}>
            <Button variant={isSystemRedesignEnabled ? 'secondary' : 'tertiary'} fullWidth isDisabled={isLoading}>
              {buttonText}
            </Button>
          </div>
        }
      />
      {goToNextFile && <Button onPress={goToNextFile}>See Next</Button>}
    </div>
  )
}
